export enum ButtonType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export enum LinkType {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}

export type ButtonLinkType = {
  buttonLabel: string
  buttonType: ButtonType
  linkType: LinkType
  linkUrl: string
}
